import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Button from 'components/basic/Button';
import Typograf from 'components/basic/Typograf';
import { HighlightTitle } from 'components/basic/Typography';

import s from './RainbowHighlight.module.scss';

interface Props {
  text: string | React.ReactElement;
  buttonText: string | React.ReactElement;
  className?: string;
  href: string;
}

const RainbowHighlight: FC<Props> = ({ text, buttonText, className, href }) => {
  return (
    <Typograf>
      <div className={cn(s.wrapper, className)}>
        <HighlightTitle
          className={cn(s.text, 'mb-sm-8 mb-md-8 mb-xl-10')}
          Tag="h2"
        >
          {text}
        </HighlightTitle>
        <Button href={href} className={s.button}>
          {buttonText}
        </Button>
      </div>
    </Typograf>
  );
};

export default RainbowHighlight;
